import { Flex, Paper, Main, NewLogo } from "@goodfill/ui-components";
import { PropsWithChildren } from "react";
import "./styles/AuthPage.scss";

interface Props {
  isLoading?: boolean;
}

export const AuthPage: React.FC<PropsWithChildren<Props>> = ({ children, isLoading }) => {
  return (
    <Main>
      <Flex verticalMargin={8}>
        <Paper>
          <Flex grow={1} direction="rowCol" items="center" justify="evenly" verticalMargin={8} horizontalMargin={8}>
            <Flex direction="rowCol" items="center" className="w-2/4 display-none" justify="center">
              <NewLogo />
            </Flex>
            <Flex
              direction="rowCol"
              items="center"
              borderLeft={"thin"}
              // Todo: make this better, not hardcoded height
              style={{ height: "650px" }}
              className="display-none"
            >
              &nbsp;
            </Flex>
            <Flex horizontalPadding={10} items="center" className="w-2/4 md-w-full padding-form" justify="center">
              {children}
            </Flex>
          </Flex>
        </Paper>
      </Flex>
    </Main>
  );
};
